import { Component, Input } from '@angular/core';
import { formatMsisdn, formatNa } from '@proximus/common-utils';
import { PlcCodes } from '@dch/products-business-logic';

@Component({
  selector: 'mprd-access-number-formatter',
  templateUrl: './access-number-formatter.component.html',
})
export class AccessNumberFormatterComponent {
  @Input() plc: string | PlcCodes;
  @Input() accessNumber: string;
  @Input() internetDescription? = '';

  constructor() {}

  format(): string {
    if (this.plc && this.accessNumber) {
      switch (this.plc) {
        case 'MV':
        case 'MI':
        case 'MMV':
        case 'MMI':
          return formatMsisdn(this.accessNumber);
        case 'FT':
        case 'TV':
          return formatNa(this.accessNumber);
        case 'FI':
          return this.internetDescription + this.accessNumber;
        default:
          return this.accessNumber;
      }
    } else {
      return this.accessNumber;
    }
  }
}
